let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hBeJ1")).then(() => parcelRequire('2aQ4f'));